import { ExpertRole } from "../types/ExpertRole"
import { useExpertsByRole } from "./useExpertsByRole"

export const useAdmin = () => {
    const { expert: admin, fetchExpert: fetchAdmin } = useExpertsByRole(ExpertRole.Admin)
    return { admin, fetchAdmin }
}